import * as yup from 'yup';
import { array } from 'yup';
import { TriStateType } from '../../types';
export const nineMioNumberSchema = yup.number().max(9999999.99).nullable();
export const stringRequriedSchema = yup
    .string()
    .nullable()
    .required('required');
/**
 * Validate if string is "UNSET, "FALSE" or "TRUE"
 */
export const triStateSchema = yup
    .string()
    .oneOf(TriStateType.getValues(), 'Not a valid TriState value');
/**
 * Force user input by only allowing "TRUE" and "FALSE" as input
 */
export const triStateNotUnsetSchema = yup
    .string()
    .oneOf([TriStateType.TRUE, TriStateType.FALSE], 'required')
    .required('required');
export const fileUploadSchema = array()
    .min(1, 'required')
    .nullable()
    .test('fileTypeError', 'fileTypeError', (value) => {
    if (value && value.some((file) => file.errors.length > 0)) {
        return false;
    }
    return true;
})
    .required('required');
